import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { RedirectService } from '../services/redirect.service';

export const authRedirectInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const redirect = inject(RedirectService);

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401) {
        router.navigate(['/unauthorized']);
        return throwError(() => new Error('Unauthorized access'));
      }

      if (error.status === 0 || (error.status >= 200 && error.status < 300)) {
        const contentType = error.headers?.get('content-type') || '';
        const responseText = error.error || error.text || '';

        if (
          contentType.includes('text/html') ||
          (typeof responseText === 'string' &&
            responseText.includes('<!DOCTYPE html>'))
        ) {
          const returnUrl = encodeURIComponent(redirect.getHref());
          const signInBase =
            environment.baseApiUrl.startsWith('http://localhost:')
              ? environment.mvcAppUrl
              : environment.baseApiUrl;
          const signInUrl = `${signInBase}/Account/SignIn?returnUrl=${returnUrl}`;
          redirect.redirect(signInUrl);

          return throwError(() => new Error('Authentication required'));
        }
      }
      return throwError(() => error);
    })
  );
};
